import { createContext, useContext } from 'react';
import { SessionDataType } from './SessionData';
import { UserDataType } from './UserData';

export type HomePlacesStatus = 'idle' | 'loading' | 'success' | 'error';

export type HomePlaceCoordinates = [number, number];

export type HomePlaceSupplierType = 'FoodMaker' | 'Shop' | 'Delivery' | string;

export type HomePlaceDeliveryTimeSlot = [string, string];
export type HomePlaceDeliveryDaySchedule = HomePlaceDeliveryTimeSlot[] | null;
export type HomePlaceDeliveryWeekSchedule = Record<number, HomePlaceDeliveryDaySchedule | undefined>;
export type HomePlaceDeliveryYearSchedule = Record<number, HomePlaceDeliveryWeekSchedule | undefined>;
export type HomePlaceDeliveryTimeSchedule = Record<number, HomePlaceDeliveryYearSchedule | undefined>;

export type HomePlaceDailyScheduleDay = {
  local_open?: string | null;
  local_close?: string | null;
  delivery_start?: string | null;
  delivery_end?: string | null;
};

export type HomePlaceDeliveryLocation = {
  delivery_conditions?: string | null;
  is_deliver_on_time?: boolean | null;
  is_deliver_to_apartment?: boolean | null;
  is_delivery_ASAP_only?: boolean | null;
  is_cashless_terminal_available?: boolean | null;
  is_delivery_available?: boolean | null;
  delivery_unavailable_notification_text_code?: string | null;
  schedule?: HomePlaceDeliveryTimeSchedule | null;
};

export type HomePlaceDeliverySchedule = Record<string, HomePlaceDeliveryLocation | undefined>;

export type HomePlaceSocialLinks = {
  telegram?: string | null;
  viber?: string | null;
  instagram?: string | null;
  whatsapp?: string | null;
  facebook?: string | null;
};

export type HomePlace = {
  pickup_address?: string | null;
  schedule_description?: string | null;
  html_page?: unknown;
  pickup_address_link?: string | null;
  delivery_schedule?: HomePlaceDeliverySchedule | null;
  pickup_point?: unknown;
  own_telegram_bot_name?: string | null;
  name_code: string;
  location: string;
  logotype?: string | null;
  is_menu?: boolean | null;
  supplier_type?: HomePlaceSupplierType | null;
  h_supplier_type?: HomePlaceSupplierType | null;
  is_order?: boolean | null;
  action_button_code?: string | null;
  contact_phone?: string | null;
  photos?: string[] | null;
  is_delivery?: boolean | null;
  is_stop_working_temporary?: boolean | null;
  email?: string | null;
  socialmedia_links?: HomePlaceSocialLinks | null;
  is_white_label?: boolean | null;
  stop_working_notice_code?: string | null;
  short_description_code?: string | null;
  delivery_order_min_amount?: number | null;
  food_maker_key: string;
  daly_schedule?: Record<string, HomePlaceDailyScheduleDay | string | null | undefined> | null;
  daily_schedule?: Record<string, HomePlaceDailyScheduleDay | string | null | undefined> | null;
};

export type HomePlacesRequest = {
  language: string;
  userId: string | null;
  location: string;
};

export type HomeDataContextType = {
  places: HomePlace[];
  status: HomePlacesStatus;
  errorMessage: string | null;
  request: HomePlacesRequest | null;
  selectedLocation: string;
  sessionData: SessionDataType | null;
  userData: UserDataType | null;
  reloadPlaces: () => void;
  selectLocation: (locationCode: string) => void;
};

const DEFAULT_HOME_DATA_CONTEXT: HomeDataContextType = {
  places: [],
  status: 'idle',
  errorMessage: null,
  request: null,
  selectedLocation: 'Montenegro_Podgorica',
  sessionData: null,
  userData: null,
  reloadPlaces: () => undefined,
  selectLocation: () => undefined,
};

const HomeDataContext = createContext<HomeDataContextType>(DEFAULT_HOME_DATA_CONTEXT);

export const useHomeData = () => useContext(HomeDataContext);

export default HomeDataContext;
